<div class="teacher-game-setup-overlay-footer" [ngClass]="'teacher-game-setup-overlay-footer--step-' + currentStep">
  <ng-container *ngIf="isResetFooter; else navigations">
    <div class="teacher-game-setup-overlay-footer__navigation">
      <brt-button [size]="'large'" [color]="'white'" [title]="'Game Session beenden'" (click)="onStopClicked()"></brt-button>
    </div>
  </ng-container>
  <ng-template #navigations>
    <div class="teacher-game-setup-overlay-footer__navigation">
      <brt-button class="teacher-game-setup-overlay-footer__navigation-prev"
                  [size]="'large'" [color]="'white'" [before-icon]="'reg-chevron-left'" [title]="prevLabel" (click)="onPrevStepClicked()"></brt-button>
      <brt-button [size]="'large'" [color]="'white'" [disabled]="selectTotalNumber === 0 && currentStep === 0"
                  [after-icon]="'reg-chevron-right'" [title]="nextLabel" (click)="onNextStepClicked()"></brt-button>
    </div>
  </ng-template>


  <div class="teacher-game-setup-overlay-footer__tools">
    <div class="teacher-game-setup-overlay-footer__reset" [ngClass]="{'visible': selectTotalNumber > 0 && currentStep == 0}" (click)="onResetClicked()">
      <span class="animline animline--white">Auswahl löschen</span> <span class="number">{{selectTotalNumber}}</span>
    </div>
  </div>
</div>
